module.exports = __webpack_public_path__ + "img/certificate5.481875fb.jpg";